import { useMutation, useQueryClient } from '@tanstack/react-query'
import { deletePlanAndRateOverrideRule } from '../../../api/plan-and-rate-override-rules-api'
import { PLAN_AND_RATE_OVERRIDE_RULES_QUERY_KEY } from '../pages/ListPlanAndRateOverride/hooks/useGetPlanAndRateOverrideRules'

export function useDeletePlanAndRateOverrideRule() {
  const queryClient = useQueryClient()

  return useMutation<void, unknown, string>({
    mutationFn: (id) => deletePlanAndRateOverrideRule(id),
    onSettled: () => {
      queryClient.invalidateQueries({
        queryKey: [PLAN_AND_RATE_OVERRIDE_RULES_QUERY_KEY],
      })
    },
  })
}
